import { render, staticRenderFns } from "./NewLowerPrice.vue?vue&type=template&id=2b6326c2&scoped=true&"
import script from "./NewLowerPrice.vue?vue&type=script&lang=js&"
export * from "./NewLowerPrice.vue?vue&type=script&lang=js&"
import style0 from "./NewLowerPrice.vue?vue&type=style&index=0&id=2b6326c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6326c2",
  null
  
)

export default component.exports